import { createReducer } from 'redux-act';
import { clearErrors, apiRequestFailure } from './errorActions';

const initialState = {
  apiError: null,
};

export const reducer = createReducer(
  {
    [clearErrors]: (state) => ({ ...state, apiError: null }),
    [apiRequestFailure]: (state, apiError) => ({ ...state, apiError }),
  },
  initialState,
);
